/* Theme-owned finder controller. No product, cart, checkout or integration writes. */
(() => {
  const modal = document.querySelector('[data-ffp-finder]');
  if (!modal || modal.dataset.initialized === 'true') return;
  modal.dataset.initialized = 'true';
  const frame = modal.querySelector('[data-ffp-finder-frame]');
  const closeButton = modal.querySelector('.ffp-finder-modal__close');
  const LABEL = 'Find the Right Floor Repair Product';
  const HASH = '#quizell-Cu6vnbMf5O9NazKY6MhpMS777400';
  const HASHES = new Set([HASH, '#find-a-solution', '#product-navigator', '#product-finder']);
  const GA = 'G-W58LGFR6HC';
  const EVENTS = new Set(['finder_view', 'finder_start', 'finder_answer', 'finder_complete', 'finder_no_match', 'finder_product_click', 'finder_collection_click', 'finder_video_play', 'finder_restart', 'finder_contact_click']);
  const PARAMS = new Set(['event_label', 'finder_journey', 'finder_question', 'finder_answer', 'finder_step', 'finder_problem', 'finder_recommendation', 'finder_product', 'finder_placement']);
  const ENTRIES = new Set(['product_alternative', 'product_cta', 'collection_cta', 'article_cta', 'guide_cta', 'navigation', 'hash']);
  const campaigns = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  const query = new URLSearchParams(location.search);
  const qa = query.get('ffp_qa') === 'debug' ? 'debug' : (query.get('ffp_qa') === '1' || modal.dataset.themeRole !== 'main' ? 'exclude' : 'off');
  const consent = () => { try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; } catch { return false; } };
  const root = () => (window.Shopify?.routes?.root || modal.dataset.rootUrl || '/').replace(/\/$/, '');
  const clean = value => typeof value === 'number' ? value : (typeof value === 'string' && /^[a-zA-Z0-9 _.:|/\-]*$/.test(value) ? value.slice(0, 100) : undefined);
  let entry = 'hash', previousFocus, ready = false, started = false, viewed = false, tagConfigured = false, navigationPending = false;
  const diagnostics = [];
  // Bounded, identifier-free QA evidence; no analytics persistence before consent.
  window.FFPFinderQA = { mode: qa, events: diagnostics };
  const log = (name, status, params = {}) => { if (qa !== 'off') { diagnostics.push({ name, status, ...params }); if (diagnostics.length > 100) diagnostics.shift(); } };
  const remember = params => {
    if (!consent() || qa === 'exclude') return;
    try { sessionStorage.setItem('ffp_finder_attribution', JSON.stringify({ entry, completed: Boolean(params.completed), expires: Date.now() + 30 * 60 * 1000 })); } catch { /* storage optional */ }
  };
  const emit = (name, params = {}) => {
    if (!consent()) { log(name, 'consent_denied'); return false; }
    const context = { event_category: 'find_a_solution', finder_entry: entry, finder_market: modal.dataset.market || 'GB', finder_store: location.hostname, finder_locale: root() || '/', finder_page_type: modal.dataset.pageType, finder_embed: 'shopify', ...params, event_label: (entry + '__' + (params.event_label || name)).slice(0, 100) };
    if (qa === 'exclude') { log(name, 'qa_excluded', context); return true; }
    if (!tagConfigured) {
      window.dataLayer = window.dataLayer || [];
      window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
      // Reuse the storefront tag and its first-party identity. Never configure a second iframe tag.
      if (![...document.scripts].some(s => s.src.startsWith('https://www.googletagmanager.com/gtag/js'))) {
        const script = document.createElement('script'); script.async = true;
        script.src = 'https://www.googletagmanager.com/gtag/js?id=' + GA;
        window.gtag('js', new Date()); document.head.append(script);
      }
      window.gtag('config', GA, { send_page_view: false });
      tagConfigured = true;
    }
    window.gtag('event', name, { ...context, send_to: GA, transport_type: 'beacon', ...(qa === 'debug' ? { traffic_type: 'internal', debug_mode: true } : {}) });
    log(name, 'sent', context);
    return true;
  };
  const sendConsent = () => {
    if (ready) frame.contentWindow.postMessage({ type: 'ffp-finder-consent', analytics: consent() ? 'granted' : 'denied' }, location.origin);
    if (!consent()) { try { sessionStorage.removeItem('ffp_finder_attribution'); } catch { /* optional */ } }
    for (const node of visibleEntries) recordImpression(node);
  };
  const loadFinder = () => {
    const params = new URLSearchParams({ embed: 'shopify', market: modal.dataset.market || 'GB', store: location.origin + root(), entry });
    for (const key of campaigns) if (query.get(key)) params.set(key, query.get(key).slice(0, 100));
    if (qa === 'exclude') params.set('ffp_qa', '1');
    if (qa === 'debug') params.set('ffp_qa', 'debug');
    if (query.get('preview_theme_id')) params.set('preview_theme_id', query.get('preview_theme_id'));
    const safeJSON = JSON.stringify('?' + params.toString()).replace(/</g, '\\u003c');
    const base = frame.dataset.finderUrl;
    frame.srcdoc = '<!doctype html><html lang="en"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><base href="' + base + '"><link rel="stylesheet" href="' + modal.dataset.finderCss + '"></head><body><div id="root"></div><script>window.FFP_FINDER_SEARCH=' + safeJSON + ';<' + '/script><script type="module" src="' + modal.dataset.finderJs + '"><' + '/script></body></html>';
  };
  const openFinder = (source = 'hash') => {
    if (modal.classList.contains('is-open')) return;
    entry = ENTRIES.has(source) ? source : 'navigation';
    previousFocus = document.activeElement; ready = false; started = false; viewed = false; navigationPending = false;
    frame.classList.remove('is-ready');
    modal.classList.add('is-open'); modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('ffp-finder-open');
    for (const el of document.body.children) { if (el !== modal && !el.contains(modal) && !el.inert) { el.inert = true; el.dataset.ffpWasInert = 'false'; } }
    emit('finder_entry_click'); loadFinder(); closeButton.focus();
  };
  const closeFinder = () => {
    modal.classList.remove('is-open'); modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ffp-finder-open');
    document.querySelectorAll('[data-ffp-was-inert]').forEach(el => { el.inert = false; delete el.dataset.ffpWasInert; });
    ready = false; frame.removeAttribute('srcdoc'); frame.classList.remove('is-ready');
    if (HASHES.has(location.hash)) history.replaceState(null, '', location.pathname + location.search);
    if (previousFocus?.isConnected) previousFocus.focus();
  };
  const visibleEntries = new Set(), impressions = new WeakSet();
  const recordImpression = node => {
    if (impressions.has(node) || !consent()) return;
    const oldEntry = entry; entry = node.dataset.ffpFinderEntry || 'navigation';
    if (emit('finder_entry_impression')) impressions.add(node);
    entry = oldEntry;
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(records => records.forEach(record => {
    if (record.isIntersecting) { visibleEntries.add(record.target); recordImpression(record.target); }
    else visibleEntries.delete(record.target);
  }), { threshold: 0.5 }) : null;
  const observed = new WeakSet();
  const prepareEntries = () => {
    document.querySelectorAll('a[href*="#"]').forEach(link => {
      const target = new URL(link.href, location.href);
      if (!HASHES.has(target.hash) || target.origin !== location.origin) return;
      if (!link.dataset.ffpFinderEntry) {
        // Keep nested icon markup, replacing only the old visible text nodes.
        const walker = document.createTreeWalker(link, NodeFilter.SHOW_TEXT);
        let node; while ((node = walker.nextNode())) node.textContent = node.textContent.replace(/Product Navigator|Find a Solution/gi, LABEL);
        link.dataset.ffpFinderEntry = 'navigation';
      }
      link.setAttribute('aria-haspopup', 'dialog'); link.setAttribute('aria-controls', modal.id);
    });
    // Covers alternate/custom product templates and dynamically rendered purchasing forms.
    if (modal.dataset.pageType === 'product') {
      const purchase = document.querySelector('#MainContent [data-add-to-cart], #MainContent form[action*="/cart/add"] [type="submit"]');
      if (purchase && !document.querySelector('[data-ffp-finder-entry="product_alternative"]')) {
        const link = document.createElement('a'); link.href = HASH; link.className = 'ffp-finder-alternative';
        link.textContent = 'Need a different product?'; link.dataset.ffpFinderEntry = 'product_alternative';
        link.setAttribute('aria-haspopup', 'dialog'); link.setAttribute('aria-controls', modal.id);
        (purchase.closest('.product-form__controls-group') || purchase).after(link);
      }
    }
    document.querySelectorAll('[data-ffp-finder-entry]').forEach(node => { if (!observed.has(node)) { observed.add(node); observer?.observe(node); } });
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]'); if (!link) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || !HASHES.has(url.hash)) return;
    event.preventDefault(); history.replaceState(null, '', location.pathname + location.search + HASH);
    openFinder(link.dataset.ffpFinderEntry || 'navigation');
  });
  window.addEventListener('message', event => {
    if (event.source !== frame.contentWindow || event.origin !== location.origin || !modal.classList.contains('is-open')) return;
    const data = event.data;
    if (!data || typeof data !== 'object') return;
    if (data.type === 'ffp-finder-ready') { ready = true; frame.classList.add('is-ready'); sendConsent(); return; }
    if (data.type === 'ffp-finder-close') { closeFinder(); return; }
    if (data.type === 'ffp-finder-focus-close') { closeButton.focus(); return; }
    if (data.type === 'ffp-finder-navigate') {
      if (navigationPending) return;
      let url; try { url = new URL(data.url); } catch { return; }
      if (url.origin !== location.origin || !url.pathname.startsWith(root() + '/') || !/\/(products|collections)\//.test(url.pathname)) return;
      navigationPending = true;
      // Give the parent event handler a turn to dispatch the beacon before leaving.
      setTimeout(() => location.assign(url.href), 150); return;
    }
    if (data.type !== 'ffp-finder-event' || data.version !== 1 || !EVENTS.has(data.event) || !ready) return;
    if (data.event === 'finder_view' && viewed) return;
    if (data.event === 'finder_start' && started) return;
    const params = {};
    for (const [key, value] of Object.entries(data.parameters || {})) { if (PARAMS.has(key) && clean(value) !== undefined) params[key] = clean(value); }
    if (emit(data.event, params)) {
      if (data.event === 'finder_view') viewed = true;
      if (data.event === 'finder_start') { started = true; remember({}); }
      if (data.event === 'finder_restart') started = false;
      if (data.event === 'finder_complete') remember({ completed: true });
    }
  });
  modal.querySelectorAll('[data-ffp-finder-close]').forEach(button => button.addEventListener('click', closeFinder));
  document.addEventListener('keydown', event => {
    if (!modal.classList.contains('is-open')) return;
    if (event.key === 'Escape') closeFinder();
    if (event.key === 'Tab' && event.target === closeButton) { event.preventDefault(); if (ready) { const options = [...frame.contentDocument.querySelectorAll('button:not([disabled]), a[href], iframe')].filter(el => el.getClientRects().length); (event.shiftKey ? options.at(-1) : options[0])?.focus(); } }
  });
  window.addEventListener('hashchange', () => { if (HASHES.has(location.hash)) openFinder(); else if (modal.classList.contains('is-open')) closeFinder(); });
  document.addEventListener('visitorConsentCollected', sendConsent);
  if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], sendConsent);
  prepareEntries();
  document.addEventListener('shopify:section:load', prepareEntries);
  // Short-lived observer for app-rendered product forms; never scans on every mutation indefinitely.
  const main = document.getElementById('MainContent');
  if (main && modal.dataset.pageType === 'product' && !document.querySelector('[data-ffp-finder-entry="product_alternative"]')) {
    const forms = new MutationObserver(() => { prepareEntries(); if (document.querySelector('[data-ffp-finder-entry="product_alternative"]')) forms.disconnect(); });
    forms.observe(main, { childList: true, subtree: true }); setTimeout(() => forms.disconnect(), 15000);
  }
  if (HASHES.has(location.hash)) openFinder();
})();
